import { gql }  from '@apollo/client';

const FETCH_SPECIALTIES_FOR_INITIATE_REFERRAL = gql`
  query($memberId: ID!, $stateCode: String) {
    member(id: $memberId){
      serviceSpecialtiesForCareHub {
        code
        name
        displayName
        servicingPlatformCode
        serviceOfferingCode
        referralType
        features(stateCode: $stateCode, family: "provider_skill") {
          code
          name
        }
      }
    }
  }
`;

export default FETCH_SPECIALTIES_FOR_INITIATE_REFERRAL;
